export const listDict = {
    employee: {
        title: 'Сотрудники',
        createTitle: 'Новый сотрудник',
        createError: 'Не удалось создать сотрудника. Попробуйте ещё раз',
        editTitle: 'Редактирование сотрудника',
        emptyTitle: 'Справочник сотрудников пуст',
        emptyText: 'Справочник хранит данные о сотрудниках вашей организации.',
        emptyCreateLink: 'Добавьте сотрудника',
        errorTitle: 'Не удалось загрузить список сотрудников',
        feedbackTitle: 'Оцените удобство справочника сотрудников',
        loaderCaption: 'Загружаем список сотрудников',
        addedAlready: 'Сотрудник уже добавлен в отчет',
    },
    client: {
        title: 'Клиенты',
        createTitle: 'Новый клиент',
        createError: 'Не удалось создать клиента. Попробуйте ещё раз',
        editTitle: 'Редактирование клиента',
        emptyTitle: 'Справочник клиентов пуст',
        emptyText: 'Справочник хранит данные о клиентах вашей организации.',
        emptyCreateLink: 'Добавьте клиента',
        errorTitle: 'Не удалось загрузить список клиентов',
        feedbackTitle: 'Оцените удобство справочника клиентов',
        loaderCaption: 'Загружаем список клиентов',
        addedAlready: 'Клиент уже добавлен в отчет',
    },
};
export const Tids = {
    employeeList: {
        addButton: 'staffWidget-employeeList-addButton',
        searchInput: 'staffWidget-employeeList-searchInput',
        submitButton: 'staffWidget-employeeList-submitButton',
        closeButton: 'staffWidget-employeeList-closeButton',
        feedbackButton: 'staffWidget-employeeList-feedbackButton',
        empty: {
            addButton: 'staffWidget-employeeList-emptyList-addButton',
        },
        error: {
            reloadButton: 'staffWidget-employeeList-error-reloadButton',
        },
        criticalError: {
            supportButton: 'staffWidget-employeeList-criticalError-supportButton',
        },
        head: {
            selectCheckbox: 'staffWidget-employeeList-head-selectCheckbox',
        },
        row: {
            getTid: (employeeId) => `staffWidget-employeeList-${employeeId}`,
            selectCheckbox: 'staffWidget-employeeList-row-selectCheckbox',
            nameText: 'staffWidget-employeeList-row-nameText',
            editButton: 'staffWidget-employeeList-row-editButton',
        },
    },
};
